// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ef3d218c","455":"af54745d"}[chunkId] + ".chunk.js";
};